import client from './client';

export interface UserListItem {
  user_id: number;
  user_uuid_id: string;
  username: string;
  fullname: string | null;
  email: string;
  is_active: number;
}

export interface UserPayload {
  username: string;
  fullname: string;
  email: string;
  password?: string;
  is_active: number;
}

export async function fetchUsers(): Promise<UserListItem[]> {
  const res = await client.get<UserListItem[]>('/users');
  return res.data;
}

export async function createUser(data: UserPayload): Promise<{ user_uuid_id: string }> {
  const res = await client.post<{ user_uuid_id: string }>('/users', data);
  return res.data;
}

export async function updateUser(uuid_id: string, data: UserPayload): Promise<void> {
  await client.put(`/users/${uuid_id}`, data);
}

export async function deleteUser(uuid_id: string): Promise<void> {
  await client.delete(`/users/${uuid_id}`);
}
